import { object, number } from 'yup'

export const setSpecialReleaseRetriever = object().shape({
  id: number()
    .negative('Must be a negative number')
    .nullable()
    .typeError('Must be a negative number'),
})
